import { Injectable } from "@angular/core";
import { BaseService } from "@dmms/core/http";
import { ReconnectRetryPolicy, stopHubConnection } from "@static/hub/hub";
import * as signalR from "@microsoft/signalr";
import { BehaviorSubject } from "rxjs";
import { HubConnection } from "@microsoft/signalr";
import { environment } from "src/environments/environment";
import { INotificationHub } from "@dmms/shared/data-access/notification/models/notification";

@Injectable({
  providedIn: "root",
})
export class NotificationsHubService {
  private connection: HubConnection;
  intentionallyClosed: boolean = false;
  counts$ = new BehaviorSubject<INotificationHub>(null);

  constructor(private readonly baseService: BaseService) {}

  initializeConnection() {
    if (
      !this.connection ||
      (this.connection &&
        this.connection["_connectionState"] === "Disconnected")
    ) {
      const url = `${environment.apiUrl}v1/notifications-hub`;
      this.connection = new signalR.HubConnectionBuilder()
        .withUrl(url, {
          accessTokenFactory: () => this.baseService.getToken(),
        })
        .withAutomaticReconnect(new ReconnectRetryPolicy())
        .build();
      this.connection.onclose(() => {
        if (!this.intentionallyClosed) {
          this.startConnection();
        }
      });

      this.startConnection();

      this.connection.on("ReceiveNotification", (data: INotificationHub) => {
        this.counts$.next(data);
      });
    }
  }

  private startConnection() {
    this.intentionallyClosed = false;

    this.connection.start().then();
  }

  stopConnection() {
    this.intentionallyClosed = true;
    stopHubConnection(this.connection);
  }
}
